import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { TokenAssinadorModel } from './tokenAssinador.model';

@Injectable()
export class TokenAssinadorService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  salvarToken(token: TokenAssinadorModel, prioridade: Boolean): Observable<TokenAssinadorModel> {
    return this.httpClient.post<TokenAssinadorModel>(this.apiURL + `/parametro-sign/save/${prioridade}`, token, this.httpOptions);
  }

  addToken(token: TokenAssinadorModel): Observable<TokenAssinadorModel> {
    return this.httpClient.post<TokenAssinadorModel>(this.apiURL + "/parametro-sign/save", token, this.httpOptions);
  }

  inserirToken(token: TokenAssinadorModel): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + `/parametro-sign/inserir`, token, this.httpOptions);
  }

  listarTokenPorCliente(clienteId: Number): any {
    return this.httpClient.get(this.apiURL + `/parametro-sign/list/${clienteId}`, this.httpOptions);
  }

  editarToken(token: TokenAssinadorModel, prioridade: Boolean): Observable<TokenAssinadorModel> {
    return this.httpClient.put<TokenAssinadorModel>(this.apiURL + `/parametro-sign/editar/${prioridade}`, token, this.httpOptions);
  }

  editToken(token: TokenAssinadorModel): Observable<TokenAssinadorModel> {
    return this.httpClient.put<TokenAssinadorModel>(this.apiURL + `/parametro-sign/editar`, token, this.httpOptions);
  }

  excluirDadoArquivistico(id) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpClient.delete(this.apiURL + `/parametro-sign/excluir/${id}`,  { headers, responseType: 'text' });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/assinatura-eletronica/token-assinador/token-assinador.service.ts